import React from 'react';
import visaLogo from '../../img/visa.png';
import mastercardLogo from '../../img/mastercard.png';
import jcbLogo from '../../img/jcb.gif';
import amexLogo from '../../img/amex.png';
import dinersLogo from '../../img/diners.jpg';
import discoverLogo from '../../img/discover.png';

/**
 * カードブランドロゴのマッピング
 */
const CARD_BRAND_LOGOS = {
  'VISA': visaLogo,
  'MASTER': mastercardLogo,
  'JCB': jcbLogo,
  'AMEX': amexLogo,
  'DINERS': dinersLogo,
  'DISCOVER': discoverLogo
};

/**
 * 決済処理中画面コンポーネント
 */
const PaymentProcessing = ({ cardBrand = 'UNKNOWN', message = '決済処理中...' }) => {
  const logoSrc = CARD_BRAND_LOGOS[cardBrand];
  
  return (
    <div style={styles.overlay}>
      <div style={styles.container}>
        {/* カードブランドロゴ */}
        {logoSrc && (
          <div style={styles.logoContainer}>
            <img 
              src={logoSrc} 
              alt={cardBrand}
              style={styles.logo}
            />
          </div>
        )}
        
        {/* ローディングスピナー */}
        <div style={styles.spinnerContainer}>
          <div style={styles.spinner}></div>
        </div>
        
        {/* メッセージ */}
        <p style={styles.message}>{message}</p>
        
        {/* サブメッセージ */}
        <p style={styles.subMessage}>
          <span>しばらくお待ちください</span><br />
          <span>画面を閉じないでください</span>
        </p>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999
  },
  container: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: '40px',
    maxWidth: '400px',
    width: '90%',
    textAlign: 'center',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
  },
  logoContainer: {
    marginBottom: '30px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '60px'
  },
  logo: {
    maxWidth: '200px',
    maxHeight: '60px',
    width: 'auto',
    height: 'auto'
  },
  spinnerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '20px'
  },
  spinner: {
    width: '50px',
    height: '50px',
    border: '5px solid #f3f3f3',
    borderTop: '5px solid #3498db',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite'
  },
  message: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '15px'
  },
  subMessage: {
    fontSize: '14px',
    color: '#666',
    lineHeight: '1.6'
  }
};

// CSSアニメーション用のスタイルタグを追加
if (!document.getElementById('payment-processing-spin-animation')) {
  const styleTag = document.createElement('style');
  styleTag.id = 'payment-processing-spin-animation';
  styleTag.textContent = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;
  document.head.appendChild(styleTag);
}

export default PaymentProcessing;